
export class CalendarEvent{
    title: string;
    start: Date | string;
    end: Date | string;
    description: string;
    location: string;
    id: string;
    startdate: Date | string;
    enddate: Date | string;
    color: string;
    calevent: CalendarEventType = CalendarEventType.Event;
    assessmentlink: string;
    originalstart: Date | string;
    originalend: Date | string;
    lessonName:string;
    moduleID:any;
    classId:any;
}
export enum CalendarEventType{
    Event,
    Batch,
    Assessment
}
